// extracted by mini-css-extract-plugin
export default {"tabla_user":"UserProfile_tabla_user__iObff","selectedImg":"UserProfile_selectedImg__3YR5b","selectedImg2":"UserProfile_selectedImg2__63ucP"};